import { Component, OnInit, Input } from '@angular/core';

export class uploadList {
  fluoroscopeId: number;
  imageId: number;
  imageDate: string;
  isChecked: boolean;
  patId: number;
  imageLabel: string;
  imageData: string;
  createdby: string;
  createdon: string;
  locId: number;
  encounterId: string;
  isActive: boolean;
  xmlImageData: string;
  isDisable: boolean;
}

@Component({
  selector: 'app-image-pdf-convert',
  templateUrl: './image-pdf-convert.component.html',
  styleUrls: ['./image-pdf-convert.component.css']
})
export class ImagePdfConvertComponent implements OnInit {

  @Input() imageArray: [];

  BindingData: uploadList[] = [];
  constructor() { }
  ngOnInit(): void {
    this.BindingData = this.imageArray;
    let arr = []
       
    for (var i = 0; i < this.imageArray.length; i++) {
      arr.push(this.imageArray[i]);
    }

    let newCont = 6;

    let el = document.getElementById('app');
    let conId = 0;
    arr.forEach((v, i) => {
      let contDiv = '';
      let chDiv = '';
      if (i % newCont == 0) {
        conId = i;
        contDiv = '<div id="c-' + conId + '" class="container"><div class="imgdiv"><img class="pdfimg" src ="' + v.imageData + '" ></div> </div>';
        el.innerHTML += contDiv;
      } else {
        let conEl = document.getElementById('c-' + conId);
        chDiv = '<div class="imgdiv"><img class="pdfimg" src="' + v.imageData + '" ></div>'
        conEl.innerHTML += chDiv;

      } 

    });

  }

}
